import * as Dialog from '@radix-ui/react-dialog';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * The notice before anything leaves the device (#387 «Migliora con IA» board, D19): what is sent,
 * to whom, that it is not kept, and that the original stays available.
 */
export function AiEnhanceDialog({
  open,
  onCancel,
  onSend,
}: {
  readonly open: boolean;
  readonly onCancel: () => void;
  readonly onSend: () => void;
}) {
  const { t } = useTranslation('tools');
  return (
    <Dialog.Root open={open} onOpenChange={(next) => (next ? undefined : onCancel())}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-[var(--scrim)]" />
        <Dialog.Content
          className="fixed top-1/2 left-1/2 z-50 grid w-[min(30rem,calc(100vw-2rem))] -translate-x-1/2
            -translate-y-1/2 gap-4 rounded-xl border border-border bg-card p-6 shadow-lg"
        >
          <Dialog.Title className="text-lg font-semibold text-foreground">
            {t('images.ai.dialogTitle')}
          </Dialog.Title>
          <Dialog.Description className="text-sm text-muted-foreground">
            {t('images.ai.dialogBody')}
          </Dialog.Description>
          <div className="flex flex-wrap justify-end gap-2">
            <Button variant="outline" type="button" onClick={onCancel}>
              {t('images.ai.cancel')}
            </Button>
            <Button type="button" onClick={onSend}>
              <Sparkles aria-hidden="true" />
              {t('images.ai.send')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
